export default "__VITE_ASSET__DEKybPZD__"